function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "28",
  height: "28",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#317B8C",
  width: "28",
  height: "28",
  rx: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 20.948a.8.8 0 01.8.8v.242a.8.8 0 11-1.6 0v-.242a.8.8 0 01.8-.8zm-.684-13.69a.914.914 0 011.244-.026l5.888 5.416c.336.31.336.81 0 1.12a.915.915 0 01-1.218 0L14.8 9.693v9.294a.8.8 0 01-.7.794l-.1.006a.8.8 0 01-.8-.8V9.72l-4.004 4.024a.916.916 0 01-1.116.122l-.1-.073a.748.748 0 01-.054-1.119z",
  fill: "#FFF",
  fillRule: "nonzero"
}))));